import { IEssentialInfo, ISocialNetworks, IUserProfile } from '../profile';
import { IAdditionalInfo } from './cv';
import { IStatusValue } from '../../../shared/components/gmc-status-input/gmc-status-input.component';
import * as moment from 'moment';
import { isMoment, Moment } from 'moment';
import { ICandidate } from '../candidate';


export interface ICvPersonalMainInfo {
  first_name?: string;
  last_name?: string;
  fullname?: string;
  candidate?: ICandidate;
  personal_email?: IStatusValue[];
  social_networks?: ISocialNetworks;
  personal_phone?: IStatusValue[];
  photo?: string;
  photo_base64?: string;
  birthday?: Moment;
  age?: number;
  country?: string;
  city?: string;
  nationality?: string;
  closest_airport?: string;
}

export class CvPersonalInfo {
  mainInfo: ICvPersonalMainInfo = {};
  additionalInfo: IAdditionalInfo;
  social_networks: ISocialNetworks;
  essentialInfo: IEssentialInfo;

  constructor(data: IUserProfile = {}) {
    this.essentialInfo = data.essentialInfo || {};
    this.social_networks = data.social_networks || {};
    this.additionalInfo = data.candidate.cv.additionalPersonalInfo || {};
    this.mainInfo.photo = data.photo || undefined;
    this.mainInfo.photo_base64 = data.photo_base64 || undefined;
    this.mainInfo.first_name = data.first_name || '';
    this.mainInfo.last_name = data.last_name || '';
    this.mainInfo.fullname = `${this.mainInfo.first_name} ${this.mainInfo.last_name}`;
    this.mainInfo.personal_phone = data.personal_phone || [];
    this.mainInfo.personal_email = data.personal_email || [];
    this.mainInfo.birthday = data.birthday ? moment(data.birthday) : null;
    this.mainInfo.country = data.country || '';
    this.mainInfo.city = data.city || '';
    this.mainInfo.nationality = data.candidate.cv.nationality || '';
    this.mainInfo.closest_airport = data.candidate.cv.closest_airport || '';
  }

  get fullname(): string {
    return `${this.mainInfo.first_name} ${this.mainInfo.last_name}`;
  }

  get age(): number {
    const { birthday } = this.mainInfo;
    return isMoment(birthday) ? moment().utc().diff(this.mainInfo.birthday, 'years') : null;
  }
}



// WEBPACK FOOTER //
// ./app/core/entities/cv/cv-personal-info.ts